import { colors } from '@mui/material';
import palette from '../../../styles/themes/palette';

type ButtonThemeBase = {
  backgroundColor: string;
  borderColor: string;
  childColor: string;
};

export type ButtonTheme = ButtonThemeBase & {
  disabled: ButtonThemeBase;
  hover: ButtonThemeBase;
};

export type ButtonThemeCollection = {
  primary: ButtonTheme;
  secondary: ButtonTheme;
};

export const defaultTheme: ButtonThemeCollection = {
  primary: {
    backgroundColor: palette.primary.dark,
    borderColor: palette.primary.dark,
    childColor: palette.primary.contrastText,
    disabled: {
      backgroundColor: colors.grey[400],
      borderColor: colors.grey[400],
      childColor: palette.primary.contrastText,
    },
    hover: {
      backgroundColor: colors.grey[700],
      borderColor: palette.primary.dark,
      childColor: palette.primary.contrastText,
    },
  },
  secondary: {
    backgroundColor: palette.primary.contrastText,
    borderColor: colors.grey[400],
    childColor: palette.primary.dark,
    disabled: {
      backgroundColor: palette.primary.contrastText,
      borderColor: colors.grey[300],
      childColor: colors.grey[300],
    },
    hover: {
      backgroundColor: palette.primary.contrastText,
      borderColor: palette.primary.dark,
      childColor: palette.primary.dark,
    },
  },
};
